import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  PreviewCustomisations: null,
};

const previewCustomisationsSlice = createSlice({
  name: "PreviewCustomisations",
  initialState,
  reducers: {
    setPreviewCustomisations: (state, action) => {
      state.PreviewCustomisations = action.payload;
    },
    setPreviewCustomisationsLogout: (state, action) => {
      state.PreviewCustomisations = null;
    },
  },
});

export const { setPreviewCustomisations, setPreviewCustomisationsLogout } =
  previewCustomisationsSlice.actions;

export default previewCustomisationsSlice.reducer;
